import React from "react";
import styled from "styled-components/macro";
import imgSelect from "../../assets/img/select.png";
import { TABLET_WIDTH, MOBILE_WIDTH } from "../../constants/dims";

const Container = styled.section`
  width: 100%;
  position: relative;
  background-color: ${(props) => props.theme.getStarted.backgroundColor};
  color: ${(props) => props.theme.getStarted.text};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Canvas = styled.div`
  max-width: ${TABLET_WIDTH}px;
  padding: 40px 20px;
  box-sizing: border-box;

  & > h2 {
    margin-bottom: -30px;
  }

  & > .row {
    display: flex;
    justify-content: space-evenly;
    margin-top: 60px;
    align-items: center;

    & > img {
      width: auto;
    }
  }
`;

const Columns = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 20px;
  box-sizing: border-box;
`;

const Column = styled.div`
  flex: 1 1 300px;
  min-width: 300px;
  text-align: center;
  box-sizing: border-box;
  margin-bottom: 24px;
  padding-right: 20px;
  padding-left: 20px;

  &:last-child {
    margin-bottom: 0;

    @media screen and (max-width: ${MOBILE_WIDTH}px) {
      padding-left: 0;
    }
  }
`;

const Columnlist = styled.div`
  flex: 1 1 300px;
  min-width: 300px;
  text-align: left;
  box-sizing: border-box;
  margin: 0px 40px 24px 40px;
  padding-right: 20px;
  padding-left: 20px;

  & > h4 {
    margin-bottom: 0px;
  }

  &:last-child {
    margin-bottom: 0;

    @media screen and (max-width: ${MOBILE_WIDTH}px) {
      padding-left: 0;
    }
  }
`;

const Plan = styled.div`
  background-color: #fff;
  padding: 10px 14px 10px 14px;
  position: relative;
  box-shadow: 0px 1px 5px #999;

  & > p {
    color: #333;
    margin-top: 0px;
    margin-bottom: 5px;
  }
  & > h4 {
    color: #000;
    margin-bottom: 0px;
  }
`;

const GetStarted = () => {
  return (
    <Container>
      <Canvas>
        <h2>Which Premium Plan Works Best For You?</h2>
      </Canvas>
      <Columns>
        <Column>
          <Plan>
            <h4>Monthly</h4>
            <p>SIMPLE AND EASY</p>
            <h4>
              <span style={{ fontSize: "200%" }}>$7.99</span>/month
            </h4>
            <div>
              <a href="https://apps.apple.com/us/app/brainquake/id1483347953">
                <img
                  src={imgSelect}
                  alt="Select"
                  style={{ width: "40%", height: "40%", marginTop: "20px" }}
                />
              </a>
            </div>
            <p>Recurring Billing</p>
            <p>JOIN FREE FOR 30 DAYS!</p>
          </Plan>
        </Column>

        <Column>
          <Plan>
            <h4>Yearly</h4>
            <p>SAVE 20%!</p>
            <h4>
              <span style={{ fontSize: "200%" }}>$6.41</span>/month
            </h4>
            <p>Total $76.99</p>
            <div>
              <a href="https://apps.apple.com/us/app/brainquake/id1483347953">
                <img
                  src={imgSelect}
                  alt="Select"
                  style={{ width: "40%", height: "40%", marginTop: "20px" }}
                />
              </a>
            </div>
            <p>Recurring Billing</p>
            <p>JOIN FREE FOR 30 DAYS!</p>
          </Plan>
        </Column>

        <Column>
          <Plan>
            <h4 style={{ marginBottom: "30px" }}>Two-Year</h4>
            <h4>
              <span style={{ fontSize: "200%" }}>$8.25</span>/month
            </h4>
            <p>Total $99.00</p>
            <div>
              <a href="https://apps.apple.com/us/app/brainquake/id1483347953">
                <img
                  src={imgSelect}
                  alt="Select"
                  style={{ width: "40%", height: "40%", marginTop: "20px" }}
                />
              </a>
            </div>
            <p>Recurring Billing</p>
            <p>JOIN FREE FOR 30 DAYS!</p>
          </Plan>
        </Column>
      </Columns>
      <Canvas>
        <h2>Enjoy Brainquake's Entire Platform</h2>
      </Canvas>
      <Columns>
        <Columnlist>
          <h4>Unlock full puzzle suite</h4>
          <p>
            Build problem-solving skills in algebra, proportional reasoning,
            arithmetic and more
          </p>
          <h4>A different kind of adaptivity</h4>
          <p>
            Our adaptive engine responds to choices, not binary right and wrong
            multiple choice answers that most other apps use.
          </p>
          <h4>Feedback, not Judgment</h4>
          <p>
            With our puzzles, you’re never wrong, you’re always on the way to
            being right.
          </p>
        </Columnlist>
        <Columnlist>
          <h4>Brand new math insights</h4>
          <p>
            The BrainQuake Score provides you with a deeper perspective on your
            math proficiency.
          </p>
          <h4>Play 100s and 100s of puzzles</h4>
          <p>
            Our puzzles increase in complexity as you improve, and we’ll be
            adding more puzzles along the way
          </p>
          <h4>Access more BrainQuake content</h4>
          <p>
            Not only will we add puzzles, but we’ll also add digital
            manipulatives to support transfer, online courses and deeper BQ
            Score assessments.
          </p>
        </Columnlist>
      </Columns>
    </Container>
  );
};
export default GetStarted;
